import React, { useEffect, useState } from 'react';
import { addSpace } from '../../Components/Tools';
import ApexCharts from 'react-apexcharts';
import axios from 'axios';
import qs from 'qs';

function RecettesExploitation(props)
{
    const [series, setSeries] = useState(undefined)
    const [options, setOptions] = useState(undefined)

    useEffect(() => {
        mount();
    }, [])


    async function mount() {

        var filename = "";
        var annees = [];
        var deb = props.user.config_budget.retro_an_deb;
        var fin = props.user.config_budget.prosp_an_fin;
        for(var an=deb; an<=fin; an++){
            annees.push(an);
        }

        /* Initialisation des options avec les années */
        var option_tmp = {
            chart: {
                toolbar: {
                    show: props.download?true:false,
                    export: {
                        svg: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        png: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        csv: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                    },
                },
                type: 'bar',
                height: 350,
                stacked: true,
            },
            title: {
                text: filename
            },
            xaxis: {
                categories: annees
            },
            yaxis: {
                labels: {
                  formatter: function (value) {
                    return addSpace(Math.round(value*100)/100, true)+' €';
                  }
                },
            },
            dataLabels: {
                formatter: (e) => {
                    return addSpace(Math.round(e/1000), true)+' k';
                }
            },
            legend: {
                fontSize: 16,
                markers: {
                    width: 12,
                    height: 12
                }
            },
            plotOptions: {
                bar: {
                    borderRadius: 4
                },
            },
            fill: {
              opacity: 1
            }
        }
        
        try {
            const res = await axios.post('https://app-slfinance.fr/api/graph.php', qs.stringify({
                'EPFL_RecettesExploitation': true,
                'id_budget': props.user.id_budget,
                'retro_an_deb': props.user.config_budget.retro_an_deb,
                'retro_an_fin': props.user.config_budget.retro_an_fin,
                'prosp_an_deb': props.user.config_budget.prosp_an_deb,
                'prosp_an_fin': props.user.config_budget.prosp_an_fin,
                'hypothese': props.hypothese,
                'nomen': props.user.nomen
            }))
            
            setOptions(option_tmp);
            setSeries([{
                name: 'TSE',
                data: res.data[0],
                color: '#fbdd55'
            },{
                name: 'Frais Facturés',
                data: res.data[1],
                color: '#61eb8f'
            }])
        } catch(error) {
            console.error('Erreur:', error.message);
        }
    }


	return (
		<div style={{margin: 5}}>
            {options && series?
			<ApexCharts
                series={series}
                options={options}
                width={'100%'}
                height={props.height?props.height:400}
                type="bar"
            />:null}
		</div>
	)
}

export default RecettesExploitation;
